import { ethers } from 'ethers';
import { getNetworkProvider } from '../../lib/eth';
import { TransactionStatus } from './types';
export async function getTransaction(address, chainId, hash) {
    const provider = await getNetworkProvider(chainId);
    if (!provider)
        return null;
    const eth = new ethers.providers.Web3Provider(provider);
    if (!address) {
        return null;
    }
    let currentNonce = null;
    try {
        currentNonce = await eth.getTransactionCount(address);
    }
    catch (error) {
        console.warn(`Could not get current nonce for account "${address}"`, error.message);
    }
    let response = null;
    try {
        response = await eth.getTransaction(hash);
    }
    catch (error) {
        console.warn(`Could not get transaction for hash "${hash}"`, error.message);
    }
    // not found
    if (response == null) {
        return null;
    }
    if (response.blockNumber == null) {
        if (currentNonce != null) {
            // replaced
            if (response.nonce < currentNonce) {
                const tx = {
                    hash,
                    status: TransactionStatus.REPLACED,
                    nonce: response.nonce
                };
                return tx;
            }
            // queued
            if (response.nonce > currentNonce) {
                const tx = {
                    hash,
                    status: TransactionStatus.QUEUED,
                    nonce: response.nonce
                };
                return tx;
            }
        }
        // pending
        const tx = {
            status: TransactionStatus.PENDING,
            ...response
        };
        return tx;
    }
    const receipt = await eth.getTransactionReceipt(hash);
    // reverted
    if (receipt == null || !receipt.status) {
        const tx = {
            status: TransactionStatus.REVERTED,
            ...response
        };
        return tx;
    }
    // confirmed
    const tx = {
        status: TransactionStatus.CONFIRMED,
        ...response,
        receipt
    };
    return tx;
}
//# sourceMappingURL=txUtils.js.map